import axios from "axios";
import { BASEURL, requestWrapper, setConfig } from "./request.util";

export const getAdmins = async () => await requestWrapper(axios.get(`${BASEURL}/admins`, setConfig()));

export const addAdmin = async (adminDetails) => await requestWrapper(axios.post(`${BASEURL}/admin/create`, adminDetails, setConfig()));

export const editAdmin = async (adminId, adminDetails) => await requestWrapper(axios.put(`${BASEURL}/admin/edit/${adminId}`, adminDetails, setConfig()));

export const addSuperAdmin = async (adminDetails) => await requestWrapper(axios.post(`${BASEURL}/admin/createSuper`, adminDetails, setConfig()));
